import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store/index";

Vue.use(VueRouter);

const routes = [
  {
    path: "*",
    redirect: "/login"
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/login.vue")
  },
  {
    path: "/",
    name: "wrap",
    component: () => import("../views/wrap.vue"),
    children: [
      {
        path: "/selfData",
        name: "selfData",
        component: () => import("../views/selfData/index.vue")
      },
      {
        path: "/users.manage",
        name: "users.manage",
        component: () => import("../views/usersManage/index.vue")
      },
      {
        path: "/users.list",
        name: "users.list",
        component: () => import("../views/userList/index.vue")
      },
      {
        path: "/users.unList",
        name: "users.unList",
        component: () => import("../views/unUserList/index.vue")
      },
      {
        path: "/users.staffSubAcc",
        name: "users.staffSubAcc",
        component: () => import("../views/usersStaffSubAcc/index.vue")
      },
      {
        path: "/users.subAcc",
        name: "users.subAcc",
        component: () => import("../views/usersSubAcc/index.vue")
      },
      {
        path: "/users.customerSubAcc",
        name: "users.customerSubAcc",
        component: () => import("../views/usersCustomerSubAcc/index.vue")
      },
      {
        path: "/settings.manager",
        name: "settings.manager",
        component: () => import("../views/settingsManager/index.vue")
      },
      {
        path: "/settings.roles",
        name: "settings.roles",
        component: () => import("../views/settingsRoles/index.vue")
      },
      {
        path: "/index.statistics",
        name: "index.statistics",
        component: () => import("../views/indexStatistics/index.vue")
      },
      {
        path: "/index.customers",
        name: "index.customers",
        component: () => import("../views/indexCustomers/index.vue")
      },
      {
        path: "/index.agents",
        name: "index.agents",
        component: () => import("../views/indexAgents/index.vue")
      },
      {
        path: "/index.general",
        name: "index.general",
        component: () => import("../views/indexGeneral/index.vue")
      },
      {
        path: "/accounting.changelogs",
        name: "accounting.changelogs",
        component: () => import("../views/accountingChangelogs/index.vue")
      },
      {
        path: "/settings.blockIPAddress",
        name: "settings.blockIPAddress",
        component: () => import("../views/settingsBlockIPAddress/index.vue")
      },
      {
        path: "/index.stats5",
        name: "index.stats5",
        component: () => import("../views/indexStats5/index.vue")
      },
      {
        path: "/index.stats6",
        name: "index.stats6",
        component: () => import("../views/indexStats6/index.vue")
      },
      {
        path: "/admin.collections",
        name: "admin.collections",
        component: () => import("../views/adminCollections/index.vue")
      },
      {
        path: "/admin.payment",
        name: "admin.payment",
        component: () => import("../views/adminPayment/index.vue")
      },
      {
        path: "/admin.methods",
        name: "admin.methods",
        component: () => import("../views/adminMethods/index.vue")
      },
      {
        path: "/admin.agentCollectionKey",
        name: "admin.agentCollectionKey",
        component: () => import("../views/adminAgentCollectionKey/index.vue")
      },
      {
        path: "/admin.agentPaymentKey",
        name: "admin.agentPaymentKey",
        component: () => import("../views/adminAgentPaymentKey/index.vue")
      },
      {
        path: "/admin.failedQueue",
        name: "admin.failedQueue",
        component: () => import("../views//adminFailedQueue/index.vue")
      },
      {
        path: "/notifications.all",
        name: "notifications.all",
        component: () => import("../views//notificationsAll/index.vue")
      },
      {
        path: "/notifications.unread",
        name: "notifications.unread",
        component: () => import("../views//notificationsUnread/index.vue")
      },
      {
        path: "/notifications.readed",
        name: "notifications.readed",
        component: () => import("../views//notificationsReaded/index.vue")
      },
      {
        path: "/payment.transactions",
        name: "payment.transactions",
        component: () => import("../views/orderP/index.vue")
      },
      {
        path: "/paymentMethod.agents",
        name: "paymentMethod.agents",
        component: () => import("../views/paymentMethodAgents/index.vue")
      },
      {
        path: "/paymentMethod.customers",
        name: "paymentMethod.customers",
        component: () => import("../views/paymentMethodCustomers/index.vue")
      },
      {
        path: "/paymentMethod.customer_p_m",
        name: "paymentMethod.customer_p_m",
        component: () => import("../views/paymentMethod/index.vue")
      },
      {
        path: "/payment.apply",
        name: "payment.apply",
        component: () => import("../views/paymentApply/index.vue")
      },
      {
        path: "/payment.setting",
        name: "payment.setting",
        component: () => import("../views/paymentSetting/index.vue")
      },
      {
        path: "/collections.transactions",
        name: "collections.transactions",
        component: () => import("../views/order/index.vue")
      },
      {
        path: "/collections.create",
        name: "collections.create",
        component: () => import("../views/createOrder/index.vue")
      },
      {
        path: "/collections.setting",
        name: "collections.setting",
        component: () => import("../views/collectionsSetting/index.vue")
      },
      {
        path: "/collections.revert",
        name: "collections.revert",
        component: () => import("../views/collectionsRevert/index.vue")
      },
      {
        path: "/collectionMethod.agents",
        name: "collectionMethod.agents",
        component: () => import("../views/collectionMethodAgents/index.vue")
      },
      {
        path: "/collectionMethod.customers",
        name: "collectionMethod.customers",
        component: () => import("../views/collectionMethodCustomers/index.vue")
      },
      {
        path: "/collections.deposit",
        name: "collections.deposit",
        component: () => import("../views/collectionsDeposit/index.vue")
      },
      {
        path: "/collectionMethod.c_m",
        name: "collectionMethod.c_m",
        component: () => import("../views/collectionMethod/index.vue")
      },
      {
        path: "/collectionMethod.customer_c_m",
        name: "collectionMethod.customer_c_m",
        component: () => import("../views/polling/index.vue")
      },
      {
        path: "/collectionMethod.customer_c_m_change",
        name: "collectionMethod.customer_c_m_change",
        component: () => import("../views/collectionMethodChange/index.vue")
      },
      {
        path: "/withdraws.setting",
        name: "withdraws.setting",
        component: () => import("../views/withdrawsSetting/index.vue")
      },
      {
        path: "/withdraws.apply",
        name: "withdraws.apply",
        component: () => import("../views/withdrawsApply/index.vue")
      },
      {
        path: "/withdraws.list",
        name: "withdraws.list",
        component: () => import("../views/withdrawsList/index.vue")
      },
      {
        path: "/withdraws.fee",
        name: "withdraws.fee",
        component: () => import("../views/withdrawsFee/index.vue")
      },
      {
        path: "/index.stats7",
        name: "index.stats7",
        component: () => import("../views/grantEnquiry/index.vue")
      },
      {
        path: "/adminNotify",
        name: "adminNotify",
        component: () => import("../views/adminNotify/index.vue")
      },
      {
        path: "/test",
        name: "test",
        component: () => import("../views/systemReport/index.vue")
      },
      {
        path: "/admin.checkBalance",
        name: "admin.checkBalance",
        component: () => import("../views/checkBalance/index.vue")
      }
    ]
  }
];

const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err);
};
const router = new VueRouter({
  mode: "history",
  routes
});

router.beforeEach((to, from, next) => {
  if (to.name == "login" || to.name == "selfData") {
    next();
    return;
  }
  let menu = store.state.menuList;
  let have = false;
  if (Object.keys(menu).length == 0) {
    next();
    return;
  }
  // return false
  Object.keys(menu).forEach(one => {
    Object.keys(menu[one].sub).forEach(name => {
      if (name == to.name) {
        have = true;
      }
    });
  });
  if (have) {
    next();
    return;
  }
  if (!have) {
    // if (to.name == "test") {
    //   next();
    //   return;
    // }
    next({ name: "selfData" });
    return;
  }
});

export default router;
